import { Download } from 'lucide-react-native';
import { useCallback } from 'react';
import { HStack } from '../../../components/primitives';
import { Button } from '../../../components/primitives/Button';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { saveBlobAsFile } from '../../../utils/saveBlobAsFile';
import { useDownloadTemplate } from '../hooks/useLeadImport';

const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function TemplateDownloadButton() {
  const { t } = useTranslation();
  const downloadTemplate = useDownloadTemplate();

  const handleDownload = useCallback(async () => {
    try {
      const blob = await downloadTemplate.mutateAsync('xlsx');
      await saveBlobAsFile(blob, 'lead-import-template.xlsx', XLSX_MIME_TYPE);
    } catch {
      // Error handled by mutation state
    }
  }, [downloadTemplate]);

  return (
    <Button
      testID="template_download_button"
      variant="ghost"
      size="sm"
      onPress={handleDownload}
      loading={downloadTemplate.isPending}
    >
      <HStack spacing="xs" align="center">
        <Download size={14} color={colors.primary[500]} />
        <Text variant="caption" color={colors.primary[500]}>
          {t('leadImport.downloadTemplate')}
        </Text>
      </HStack>
    </Button>
  );
}
